var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('level-selector',{attrs:{"selectorData":_vm.shortNodeList,"title":_vm.title},on:{"selectItem":_vm.selectItemListener}})}
var staticRenderFns = []

export { render, staticRenderFns }